(ns rothko.markdown.core
  (:require ["marked" :as marked]
            ["remove-markdown" :as remove-markdown-npm]))

(def remove-markdown remove-markdown-npm)

(let [marked (.setOptions marked #js {:gfm true
                                      :tables true})]
  (defn md->html
    [md]
    (when md
      (marked md))))


(defn with-markdown
  [props text]
  (assoc props :dangerouslySetInnerHTML
         {:__html (md->html text)}))

;; TODO: does this need to be implemented?
;; (defn with-markdown-message
;;   [props message-key]
;;   (assoc props :dangerouslySetInnerHTML
;;          {:__html (md->html (lookup-text message-key))}))
